import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-daterange', 'TIME_START', 'Laika sākums');
Labels.set('ui-daterange', 'TIME_END', 'Laika beigas');
